/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourcedirect2Inputs */

const en_summarysourcedirect2 = /** @type {(inputs: Summarysourcedirect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct or unknown`)
};

const de_summarysourcedirect2 = /** @type {(inputs: Summarysourcedirect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkt oder unbekannt`)
};

/**
* | output |
* | --- |
* | "Direct or unknown" |
*
* @param {Summarysourcedirect2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourcedirect2 = /** @type {((inputs?: Summarysourcedirect2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourcedirect2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourcedirect2(inputs)
	return de_summarysourcedirect2(inputs)
});
export { summarysourcedirect2 as "summarySourceDirect" }